import * as api from './api';
import * as types from './mutations';

const state = {
    filters: {},
    matches: [],
    paginator: {},
    sortCriteria: 'created_at',
    activeFilters: [],
    isProcessing: false,
    listingHeight: 0,
};

const getters = {

};

const mutations = {
    [types.SET_FILTERS](state, filters) {
        state.filters = filters;
    },

    [types.UPDATE_PAGINATOR](state, paginator) {
        state.paginator = paginator;
    },

    [types.UPDATE_RESULTS](state, results) {
        state.matches = state.paginator.current_page === 1
            ? results
            : [...state.matches, ...results];
    },

    [types.UPDATE_ACTIVE_FILTERS](state, filters) {
        state.activeFilters = filters;
    },

    [types.SET_LISTING_HEIGHT](state, height) {
        state.listingHeight = height;
    },

    [types.CHANGE_SORT_CRITERIA](state, value) {
        state.sortCriteria = value;
    },

    [types.SET_PROCESSING_STATE](state, isProcessing) {
        state.isProcessing = isProcessing;
    }
};

const actions = {
    getFilters({commit, state}) {
        if (! _.isEmpty(state.filters)) return;

        return new Promise((resolve, reject) => {
            axios.get(api.getFilters)
                .then(({data}) => {
                    commit(types.SET_FILTERS, data.filters);
                    resolve();
                });
        });
    },

    findCoursesByCriteria({commit, state}, {criteria, page = 1, viewAll = false, courseList = []}) {
        commit(types.SET_PROCESSING_STATE, true);

        return new Promise((resolve, reject) => {
            axios.post(api.findCoursesByCriteria(page), {...criteria, orderBy: state.sortCriteria, viewAll, courseList})
                .then(({data}) => {
                    commit(types.UPDATE_ACTIVE_FILTERS, _.assign({}, criteria, {keyword: []}));
                    commit(types.UPDATE_PAGINATOR, data.meta.pagination);
                    commit(types.UPDATE_RESULTS, data.data);
                    resolve();
                })
                .catch(({response}) => reject(response))
                .done(_ => commit(types.SET_PROCESSING_STATE, false));
        });
    },
    
    searchByKeyword({commit, state}, {keyword, scout}) {
        const perPage = 1000;
        commit(types.UPDATE_ACTIVE_FILTERS, _.assign({}, state.activeFilters, {formats: [], levels: [], topics: [], authors: []}));

        const courseSearchSettings = {
            attributesToRetrieve: ['title', 'slug', 'duration', 'format', 'level', 'links', 'isCredential', 'lzRoute'],
            hitsPerPage: perPage
        };

        const queries = [{
            indexName: 'mha_courses',
            query: keyword,
            params: courseSearchSettings
            }, {
            indexName: 'mha_credential_courses',
            query: keyword,
            params: courseSearchSettings
        }];

        scout.client.multipleQueries(queries).then(({ results }) => {
            let hits = []
            results.forEach(result => {
                hits = _.union(result.hits, hits)
            });

            if (hits.length) {
                commit(types.UPDATE_ACTIVE_FILTERS, _.assign({}, state.activeFilters, {keyword: [keyword]}));
                commit(types.UPDATE_RESULTS, hits);
                commit(types.UPDATE_PAGINATOR, {
                    count: hits.length,
                    current_page: 1,
                    links: [],
                    per_page: perPage,
                    total: hits.length,
                    total_pages: 1
                })
            }
        });
    }
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
};